import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Output } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import {
  ButtonsModule,
  CardModule,
  IconModule,
  LoadingModule,
  LoadingService,
} from 'axis-components';
import { Logger } from '../../../_core/logger.service';
import { NotificationService } from '../../../_services/notification/notification.service';
import { PdfService } from '../../../_services/pdf/pdf.service';
import { RequestService } from '../../../_services/request/request.service';
import { AnalyticsService } from '../../../_shared/analytics/analytics.service';
import { FormType, PDFGenerationStatus } from '../../../config/constants';
import {
  DefaultNote,
  DigitalContent,
  NonDigitalContent,
  Messages,
  FileNames,
} from './pip-thankyou.constants';
import { PipBaseRulesService } from '../../../state-disclosures/pip/services/pip-base-rules.service';
import { NondigitalService } from '../../../_services/pip/nondigital.service';
@Component({
  selector: 'app-pip-thankyou',
  templateUrl: './pip-thankyou.component.html',
  styleUrls: ['./pip-thankyou.component.scss'],
  standalone: true,
  imports: [
    CardModule,
    ButtonsModule,
    IconModule,
    RouterModule,
    LoadingModule,
    CommonModule,
  ],
})
export class PipThankYouComponent {
  // Event emitted to playground component when workflow completes
  @Output() workflowCompletePlayground = new EventEmitter<void>();
  title;
  content = '';
  subcontent;
  showDocument = false;

  downloadInProgress = false;
  requestKey = '';

  isPipEnabled = false;
  nonDigital: any;

  note = DefaultNote.Note;
  public pipBaseRulesService = inject(PipBaseRulesService);
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private pdfService: PdfService,
    private requestService: RequestService,
    private analyticsService: AnalyticsService,
    private notificationService: NotificationService,
    private loadingService: LoadingService,
    private readonly nondigitalService: NondigitalService,
  ) {}
  ngOnInit(): void {
    this.requestKey = this.requestService.getRequestKey() || '';
    this.requestService.refreshRequestData(true).subscribe({
      next: (data) => {
        this.initializeFromApiData();
      },
      error: (err) => {
        console.error(Messages.ErrorFetchingData, err);
        // Fallback to existing data if API call fails
        this.initializeFromApiData();
      },
    });
    this.goTop();
    
  }
  private initializeFromApiData(): void {
    let formTypeList = this.requestService.requestFormTypeList;
    this.isPipEnabled = formTypeList.includes(FormType.PIP);
    // Determine content and display settings based on step data
    this.determineContentFromSteps();
  }

  private determineContentFromSteps(): void {
    const pipConfig = this.requestService.getThankYouPageConfig('pip');

    if (pipConfig.isDigital) {
      // Different content based on whether PIP is enabled or not
      if (this.isPipEnabled) {
        this.content = DigitalContent.WithPip;
      } else {
        this.content = DigitalContent.WithoutPip;
      }
      this.showDocument = true;
    } else if (pipConfig.isNonDigitalMail || pipConfig.isNonDigitalDownload) {
      // Different content based on whether PIP is enabled or not for non-digital scenarios
      if (this.isPipEnabled) {
        if (pipConfig.isNonDigitalMail) {
          this.content = NonDigitalContent.rejectionOptMessage;
        } else {
          this.content = NonDigitalContent.WithPip;
        }
      } else {
        this.content = NonDigitalContent.rejectionOptMessage;
      }
      this.showDocument = true;
    }
  }

  // Helper methods for template logic
  isPipNonDigital(): boolean {
    const pipConfig = this.requestService.getThankYouPageConfig('pip');
    return pipConfig.isNonDigitalDownload || pipConfig.isNonDigitalMail;
  }

  downloadPIPDocuments() {
    this.downloadInProgress = true;
    this.analyticsService.logDownloadButtonClick(FormType.PIP);
    this.getPdfFromGDMS();
  }

  getPdfFromGDMS() {
    this.downloadInProgress = true;
    this.pdfService.getPdfFromGDMS(FormType.PIP, this.requestKey).subscribe({
      next: (response) => {
        this.downloadInProgress = false;
        this.handlePdfResponse(response);
      },
      error: (err) => {
        this.downloadInProgress = false;
        console.error('Error generating PDF:', err);
        this.notificationService.showNotification(
          Messages.DocumentsUnavailableError,
          'error',
        );
      },
    });
  }


  handlePdfResponse(response: any) {
    const blob = new Blob([response], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    // To download:
    const a = document.createElement('a');
    a.href = url;
    a.download = FileNames.PipDocuments;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  goTop(): void {
    // reset the page when changing route
    window.scrollTo(0, 0);
  }
  onContinue(): void {
    this.router.navigate(['/thank-you'], {
      queryParamsHandling: 'preserve',
    });
  }
}
